<div class="containerWrapper">
  <h1>{{ 'Add Vendor' | translate }}</h1>
  <div class="vendorDetail">
    <!-- 
      Reactive form using Angular FormGroup (vendorForm)
      (ngSubmit) calls createProject() when the form is submitted
    -->
    <form [formGroup]="vendorForm" id="vendorForm" (ngSubmit)="createProject()">

      <!-- SECTION: Account Information -->
      <div class="vendorHeader">
        <h1>{{ 'Account Info' | translate }}</h1>
      </div>

      <div class="vendorForm">
        <!-- LEFT SIDE FIELDS -->
        <div class="left">
          <!-- First Name -->
          <mat-form-field appearance="outline">
            <mat-label>{{ 'First Name' | translate }}</mat-label>
            <input required matInput formControlName="firstName" [(ngModel)]="firstName" />
            <mat-error> {{ 'First Name is required' | translate }} </mat-error>
          </mat-form-field>

          <!-- Store Name -->
          <!-- <mat-form-field appearance="outline">
            <mat-label>{{ 'Store Name' | translate }}</mat-label>
            <input required matInput formControlName="storeName" [(ngModel)]="storeName" />
            <mat-error> {{ 'Store Name is required' | translate }} </mat-error>
          </mat-form-field> -->
          <!-- Phone Number -->
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Phone Number' | translate }}</mat-label>
            <input type="number" required matInput formControlName="phoneNumber" [(ngModel)]="phoneNumber" />
            <mat-error> {{ 'Phone Number is required' | translate }} </mat-error>
          </mat-form-field>
          <!-- Username -->
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Username' | translate }}</mat-label>
            <input required matInput autocomplete="off" formControlName="userName" [(ngModel)]="userName" />
            <mat-error> {{ 'User Name is required' | translate }} </mat-error>
          </mat-form-field>
          <!-- Password -->
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Create Password' | translate }}</mat-label>
            <input  required matInput autocomplete="off" formControlName="vendorPassword" [(ngModel)]="vendorPassword" />
            <mat-error> {{ 'Password is required' | translate }} </mat-error>
          </mat-form-field>
        </div>
        <!-- RIGHT SIDE FIELDS -->
        <div class="right">
          <!-- Last Name -->
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Last Name' | translate }}</mat-label>
            <input required matInput formControlName="lastName" [(ngModel)]="lastName" />
            <mat-error> {{ 'Last Name is required' | translate }} </mat-error>
          </mat-form-field>
          <!-- Email -->
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Email' | translate }}</mat-label>
            <input type="email" required matInput autocomplete="off" formControlName="vendorEmail" [(ngModel)]="vendorEmail" />
            <mat-error> {{ 'Email is required' | translate }} </mat-error>
          </mat-form-field>
          <!-- Store URL -->
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Store URL' | translate }}</mat-label>
            <input matInput formControlName="storeUrl" [(ngModel)]="storeUrl" />
          </mat-form-field>
        </div>
      </div>

      <!-- SECTION: Payment Options -->
      <div class="vendorHeader">
      <h1>{{ 'Payment Options' | translate }}</h1>
      </div>
     <div class="vendorForm">
       <!-- LEFT SIDE FIELDS -->
        <div class="left">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Account Name' | translate }}</mat-label>
            <input matInput formControlName="accountName" [(ngModel)]="accountName" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Account Type' | translate }}</mat-label>
            <input  matInput formControlName="accountType" [(ngModel)]="accountType" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Bank Address' | translate }}</mat-label>
            <input  matInput formControlName="bankAdress" [(ngModel)]="bankAdress" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'IBAN' | translate }}</mat-label>
            <input  matInput  formControlName="iban" [(ngModel)]="iban" />
          </mat-form-field>
        </div>

        <!-- RIGHT SIDE FIELDS -->
        <div class="right">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Account Number' | translate }}</mat-label>
            <input matInput formControlName="accountNumber" [(ngModel)]="accountNumber" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Bank Name' | translate }}</mat-label>
            <input  matInput formControlName="bankName" [(ngModel)]="bankName" />
          </mat-form-field>
         <mat-form-field appearance="outline">
            <mat-label>{{ 'Routing Number' | translate }}</mat-label>
            <input  matInput autocomplete="off" formControlName="routingNumber" [(ngModel)]="routingNumber" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Swift' | translate }}</mat-label>
            <input  matInput formControlName="swift" [(ngModel)]="swift" />
          </mat-form-field>
        </div>

      </div>

    </form>
  </div>
</div>
